import React from 'react';
import { Task } from '@trnsact/trnsact-shared-types';
import FlagIcon from '@mui/icons-material/Flag';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { TableCell } from '../../Table/TableCell';
import { priorityColors } from '../../../constants/tasks';

interface Props {
  task: Task;
}

export const PriorityCell = ({ task }: Props) => {
  const classes = useStyles();

  const { priority } = task;

  return (
    <TableCell>
      <Box className={classes.cellContent}>
        <FlagIcon style={{ color: priorityColors[priority!] }} />

        <Typography className={classes.value} variant="body2">
          {priority!}
        </Typography>
      </Box>
    </TableCell>
  );
};

const useStyles = makeStyles({
  cellContent: {
    zIndex: 2,
    gap: '0.3rem',
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  value: {
    textTransform: 'capitalize',
  },
});
